/*
*###############################################################################
*Module Name                   : VoucherSellDetails.js                   #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Thursday, January 6th 2022, 9:53:47 am        #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
import React, { useState, useEffect } from "react"
import { Row, Col, Button, Label } from "reactstrap"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import { ValidateVouchers } from "./VoucherSellController"
import DPAlert from "../../../framework/widgets/DPAlert"
import { Numeric, DecimalValidation } from "../../../framework/validators/TextValidation" // Textbox input validations
import DPSearchBoxDynamicHeadOffice from "framework/components/DPSearchBoxDynamicHeadOffice"
const VoucherSellDetails = ({
  DataRow,
  setDetailRows,
  BookChange,
  SupplierCode,
  blDiasableGrid,
  strFromLocation,
  menuCode,
  LocationCode,
  menuName,
  updateCalculatedRows,
  SetLoadingAlert,
  SetLoadingAlerttitle
}) => {

  useEffect(() => {
    updateCalculatedRows();
  }, [DataRow.length])


  async function changeRowValueChanges(value, id, element) {

    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    const newObject = { ...DataRow[objectIndex], [element]: value };
    setDetailRows(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };


  async function handleObjectChange(row, id) {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    setDetailRows(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = row;
      return newDataRow;
    });
  }


  async function AddRow() {

    //if there is a row with empty values, do not add a new row

    const emptyRow = DataRow.find(x => x.code == "");

    if (emptyRow) {
      return false;
    }


    var detailRows = [...DataRow];

    const maxId = detailRows.reduce((max, row) => Math.max(max, row.id), 0);

    detailRows.push({
      code: "",
      desc: "",
      VoucherFrom: "",
      VoucherTo: "",
      DiscPer: 0,
      DiscAmt: 0,
      Amount: 0,
      Selling: 0,
      Cost: 0,
      id: maxId + 1,
      disable: false,
      count: 0,
      disableFrom: false,
      disableTo: true,
    })

    setDetailRows(detailRows)

  }


  async function RemoveRow(id) {
    setDetailRows(prevDetailRows => {
      const updatedRows = prevDetailRows.filter(x => x.id !== id);

      if (updatedRows.length === 0) {
        updatedRows.push({
          code: "",
          desc: "",
          VoucherFrom: "",
          VoucherTo: "",
          DiscPer: 0,
          DiscAmt: 0,
          Amount: 0,
          Selling: 0,
          Cost: 0,
          id: 1,
          disable: false,
          count: 0,
          disableFrom: false,
          disableTo: true,
        });
      }

      return updatedRows;
    });

    return true;
  }

  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          <table style={{ fontSize: "11px" }} id={"VoucherPODet"}>
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th style={{ textAlign: "left" }}>Group Code</th>
                <th>&nbsp;</th>
                <th style={{ textAlign: "left" }}>Group Description </th>
                <th style={{ textAlign: "left" }}>Voucher No From</th>
                <th style={{ textAlign: "left" }}>Voucher No To</th>
                <th style={{ textAlign: "right" }}>Count</th>
                <th style={{ textAlign: "right" }}>Disc %</th>
                <th style={{ textAlign: "right" }}>Disc. Amt</th>
                <th style={{ textAlign: "right" }}>Amount</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {(DataRow).map((formRow, key) => (
                <TableRow
                  FormRow={formRow}
                  Key={key}
                  RemoveRow={RemoveRow}
                  DataRow={DataRow}
                  Disabled={blDiasableGrid}
                  BookChange={BookChange}
                  SupplierCode={SupplierCode}
                  strFromLocation={strFromLocation}
                  menuCode={menuCode}
                  LocationCode={LocationCode}
                  changeRowValueChanges={changeRowValueChanges}
                  handleObjectChange={handleObjectChange}
                  menuName={menuName}
                  updateCalculatedRows={updateCalculatedRows}
                  SetLoadingAlert={SetLoadingAlert}
                  SetLoadingAlerttitle={SetLoadingAlerttitle}
                />
              ))}
            </tbody>

          </table>
          <Button
            onClick={() => {
              AddRow()
            }}
            disabled={blDiasableGrid}
            color="success"
            className="mt-1"
            size="sm"
          >
            <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
          </Button>
        </Col>
      </Row>
    </React.Fragment>
  )
}
export default VoucherSellDetails

const TableRow = ({ FormRow, Key, RemoveRow, Disabled, BookChange,
  SupplierCode, strFromLocation, menuCode, changeRowValueChanges,
  handleObjectChange, DataRow, menuName, updateCalculatedRows, SetLoadingAlert, SetLoadingAlerttitle }) => {

  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")


  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [modal_xlargeVoucherFrom, setmodal_xlargeVoucherFrom] = useState(false)
  const [modal_xlargeVoucherTo, setmodal_xlargeVoucherTo] = useState(false)


  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)

  const [groupFilter, SetGroupFilter] = useState('a')




  async function clickSearch() {
    tog_xlarge()
  }


  //**Set the Default sort column and Sort order*/
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]



  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  function tog_xlargeBookNoFrom() {
    setmodal_xlargeVoucherFrom(!modal_xlargeVoucherFrom)
    removeBodyCss()
  }

  function tog_xlargeBookNoTo() {
    setmodal_xlargeVoucherTo(!modal_xlargeVoucherTo)
    removeBodyCss()
  }
  //** Columns to be populated/Displayed within the Search window */



  const Hed_SelectRowSearch = async (e, row, isSelect, rowIndex) => {
    if (CodeValidation(row.VCG_CODE, "txtcode" + Key)) {
      await VoucherGroupCodeSearch(row.VCG_CODE)
      setmodal_xlarge(!modal_xlarge)
    }
    else {
      setAlertDescription("Code already used")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
    }
  }


  const Hed_SelectRowSearchVoucherFrom = (e, row, isSelect, rowIndex) => {
    if (CodeValidation(row.VC_NUMBER, "txtVoucherFrom" + Key)) {

      var currentRow = FormRow
      currentRow.VoucherFrom = row.VC_NUMBER
      handleObjectChange(currentRow, FormRow.id)

      setmodal_xlargeVoucherFrom(!modal_xlargeVoucherFrom)
    }
    else {
      setAlertDescription("Voucher No already used")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
    }
  }


  const Hed_SelectRowSearchVoucherTo = (e, row, isSelect, rowIndex) => {
    if (CodeValidation(row.VC_NUMBER, "txtVoucherTo" + Key)) {

      if (FormRow.VoucherFrom <= row.VC_NUMBER) {

        var currentRow = FormRow
        currentRow.VoucherTo = row.VC_NUMBER
        handleObjectChange(currentRow, FormRow.id)

        setmodal_xlargeVoucherTo(!modal_xlargeVoucherTo)
        CheckAllocatedVoucherNumber(FormRow.VoucherFrom, row.VC_NUMBER)
      }
      else {
        setAlertDescription("Voucher To Number should be greater than Voucher From Number")
        setAlertConfirmOption(4)
        setsweetAlertShow(true)
      }

    }
    else {
      setAlertDescription("Voucher No already used")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
    }
  }



  function CheckAllocatedVoucherNumber(FromVoucher, ToVoucher, code, strFromLocation) {
    var currentRow = FormRow
    if (ToVoucher != "" && FromVoucher != "" && code != "" && strFromLocation != "") {

      fetch(`${ApiURL}VoucherTRO/CheckAllocatedVoucherNumber/${FromVoucher}/${ToVoucher}/${code}/${strFromLocation}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {
            setAlertDescription("This Following Voucher number are already allocated " + responseData.data)
            setAlertConfirmOption(4)
            setsweetAlertShow(true)

            currentRow.VoucherTo = ""
            handleObjectChange(currentRow, FormRow.id)
          }
        })
    } else {
      // setVoucherTo("")
    }
  }


  async function VoucherGroupCodeSearch(value) {
    var currentRow = FormRow
    if (value != "") {

      SetLoadingAlert(true)
      SetLoadingAlerttitle("Fetching....")
      fetch(`${ApiURL}VoucherSale/Group/search/${value}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      }).then(Response => Response.json())
        .then(async (responseData) => {
          if (responseData.success == true) {

            const dt = responseData.data[0]

            currentRow.code = dt.strCode
            currentRow.desc = dt.strName
            currentRow.Selling = dt.dbValue
            currentRow.Cost = dt.dbCost
            currentRow.disable = true
            await handleObjectChange(currentRow, FormRow.id)
            await updateCalculatedRows();

          } else {
            currentRow.code = ""
            currentRow.desc = ""
            currentRow.Selling = 0
            currentRow.Cost = 0
            currentRow.disable = false
            await handleObjectChange(currentRow, FormRow.id)
            setAlertDescription("Invalid Voucher Group Code")
            setAlertConfirmOption(4)
            setsweetAlertShow(true)
            await updateCalculatedRows();
          }
        }).catch((error) => {
          console.log("Error")
        }).finally(() => {
          SetLoadingAlert(false)
        })
    } else {
      currentRow.code = ""
      currentRow.desc = ""
      currentRow.Selling = 0
      currentRow.Cost = 0
      currentRow.disable = false
      await handleObjectChange(currentRow, FormRow.id)
      await updateCalculatedRows();
    }

  }


  async function VoucherCodeSearch(row, type) {

    if (type == 1) {
      if (row.VoucherFrom == "") return false
    } else {
      if (row.VoucherTo == "") return false
    }

    if (type != 1) {
      if (parseInt(row.VoucherTo) < parseInt(row.VoucherFrom)) {
        setAlertDescription("Voucher To Number should be greater than Voucher From Number")
        setAlertConfirmOption(4)
        setsweetAlertShow(true)
        changeRowValueChanges("", FormRow.id, "VoucherTo")
        return false
      }
    }

    if (strFromLocation == "") {
      setAlertDescription("Please Select From Location")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)

      if (type == 1) {
        changeRowValueChanges("", FormRow.id, "VoucherFrom")
      } else {
        changeRowValueChanges("", FormRow.id, "VoucherTo")
      }

      return false;
    }

    if (row.code == "") {
      setAlertDescription("Please Select Voucher Group Code")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)

      if (type == 1) {
        changeRowValueChanges("", FormRow.id, "VoucherFrom")
      } else {
        changeRowValueChanges("", FormRow.id, "VoucherTo")
      }

      return false;
    }

    try {
      SetLoadingAlert(true)
      SetLoadingAlerttitle("Validating....")
      var responseData = await ValidateVouchers(row.code, row.VoucherFrom, row.VoucherTo, strFromLocation)


      if (responseData.success == false) {
        setAlertDescription(responseData.message)
        setAlertConfirmOption(4)
        setsweetAlertShow(true)

        if (type == 1) {
          changeRowValueChanges("", FormRow.id, "VoucherFrom")
        } else {
          changeRowValueChanges("", FormRow.id, "VoucherTo")
        }


        return false;
      }

      if (type == 1) {
        var currentRow = FormRow
        currentRow.disableFrom = true
        currentRow.disableTo = false
        handleObjectChange(currentRow, FormRow.id)
      } else {
        var currentRow = FormRow
        currentRow.disableTo = true
        currentRow.count = responseData.rows
        await handleObjectChange(currentRow, FormRow.id)
        await updateCalculatedRows();
      }

      return true;


    } catch {
      console.log("Error")
    } finally {
      SetLoadingAlert(false)
    }



  }

  const CodeValidation = (strCode) => {

    var filteredCode = DataRow.filter(x => x.code == strCode);

    if (filteredCode.length > 1) {
      return false;
    }

    return true;

  }


  return (
    <tr key={FormRow.id}>
      <td>
        <Row className="mb-0">
          <Col md="12">{Key + 1}</Col>
        </Row>
      </td>
      <td style={{ width: "150px" }}>
        <DPTextBoxforgrid
          textType="text"
          maxLength={6}
          id={"txtcode" + Key}
          value={FormRow.code}
          disabled={Disabled ? true : FormRow.disable}
          onChange={e => {
            changeRowValueChanges(e.target.value, FormRow.id, "code")
          }}
          onBlur={e => {
            if (CodeValidation(e.target.value, "txtcode" + Key)) {
              VoucherGroupCodeSearch(e.target.value)
            } else {
              setAlertDescription("Code already used")
              setAlertConfirmOption(4)
              setsweetAlertShow(true)
            }
          }}
        />
      </td>
      <td>
        <Button
          outline
          color="success"
          disabled={Disabled ? true : FormRow.disable}
          id={"btnSearch" + Key}
          onClick={clickSearch}
          size="sm"
        >
          <i
            className="mdi mdi-search-web"
            style={{ fontSize: "12px" }}
          ></i>
        </Button>
      </td>
      <td style={{ width: "250px" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          textType="text"
          maxLength="8"
          id={"txtdesc" + Key}
          value={FormRow.desc}
          disabled={true}
          onChange={e => {
            changeRowValueChanges(e.target.value, FormRow.id, "desc")
          }}
        ></DPTextBoxforgrid>
      </td>

      <td style={{ width: "150px" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          textType="text"
          id={"txtVoucherFrom" + Key}
          value={FormRow.VoucherFrom}
          disabled={Disabled ? true : FormRow.disableFrom}
          onChange={e => {
            let value1 = Numeric(e.target, 15, 0, false)
            changeRowValueChanges(value1, FormRow.id, "VoucherFrom")
          }}
          onBlur={async (e) => {
            var result = await VoucherCodeSearch(FormRow, 1)
          }}
        ></DPTextBoxforgrid>
      </td>

      <td style={{ width: "150px" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          textType="text"
          disabled={Disabled ? true : FormRow.disableTo}
          id={"txtVoucherTo" + Key}
          value={FormRow.VoucherTo}
          onChange={e => {
            let value1 = Numeric(e.target, 15, 0, false)
            changeRowValueChanges(value1, FormRow.id, "VoucherTo")
          }}
          onBlur={async (e) => {
            var result = await VoucherCodeSearch(FormRow, 2)
          }}
        ></DPTextBoxforgrid>
      </td>

      <td style={{ width: "70px" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          textType="text"
          textAlign={"right"}
          disabled={true}
          id={"count" + Key}
          value={FormRow.count}

        ></DPTextBoxforgrid>
      </td>

      <td>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          textType="text"
          textAlign={"right"}
          disabled={Disabled}
          id={"discPer" + Key}
          value={FormRow.DiscPer}
          onChange={async (e) => {
            let value1 = Numeric(e.target, 6, 2, false)
            await changeRowValueChanges(value1, FormRow.id, "DiscPer")

          }}
          onBlur={async (e) => {
            var currentRow = FormRow
            var currentValue = DecimalValidation(e.target.value)
            if (currentValue != "") {
              if (currentValue > 100) {
                currentRow.DiscPer = 100
                await handleObjectChange(currentRow, FormRow.id)
              } else if (currentValue < 0) {
                currentRow.DiscPer = 0
                await handleObjectChange(currentRow, FormRow.id)
              } else {
                currentRow.DiscPer = parseFloat(currentValue)
                await handleObjectChange(currentRow, FormRow.id)

              }
            } else {
              currentRow.DiscPer = 0
              await handleObjectChange(currentRow, FormRow.id)
            }
            updateCalculatedRows();

          }}
          onKeyPress={async (e) => {

            if (e.key === 'Enter') {
              document.getElementById("DiscAmt" + Key).focus();
            }

            // var currentRow = FormRow
            // var currentValue = e.target.value
            // if (currentValue != "") {
            //   if (currentValue > 100) {
            //     currentRow.DiscPer = 100
            //     await handleObjectChange(currentRow, FormRow.id)
            //   } else if (currentValue < 0) {
            //     currentRow.DiscPer = 0
            //     await handleObjectChange(currentRow, FormRow.id)
            //   }
            // } else {
            //   currentRow.DiscPer = 0
            //   await handleObjectChange(currentRow, FormRow.id)
            // }
            // updateCalculatedRows();

          }}
        />
      </td>
      <td>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          textType="text"
          disabled={Disabled}
          textAlign={"right"}
          id={"DiscAmt" + Key}
          value={FormRow.DiscAmt}
          onChange={async (e) => {
            let value1 = Numeric(e.target, 15, 2, false)
            await changeRowValueChanges(value1, FormRow.id, "DiscAmt")

          }}
          onBlur={async (e) => {

            var currentRow = FormRow
            var currentValue = DecimalValidation(e.target.value)
            if (currentValue != "") {
              if (currentValue > FormRow.Amount) {
                currentRow.DiscAmt = parseFloat(FormRow.Amount)
                await handleObjectChange(currentRow, FormRow.id)
              } else if (currentValue < 0) {
                currentRow.DiscAmt = 0
                await handleObjectChange(currentRow, FormRow.id)
              } else {
                currentRow.DiscAmt = parseFloat(currentValue)
                await handleObjectChange(currentRow, FormRow.id)
              }
            } else {
              currentRow.DiscAmt = 0
              await handleObjectChange(currentRow, FormRow.id)
            }
            updateCalculatedRows();
          }}
          onKeyPress={async (e) => {

            if (e.key === 'Enter') {

              var currentRow = FormRow
              var currentValue = e.target.value
              if (currentValue != "") {
                if (currentValue > FormRow.Amount) {
                  currentRow.DiscAmt = parseFloat(FormRow.Amount)
                  await handleObjectChange(currentRow, FormRow.id)
                } else if (currentValue < 0) {
                  currentRow.DiscAmt = 0
                  await handleObjectChange(currentRow, FormRow.id)
                }
              } else {
                currentRow.DiscAmt = 0
                await handleObjectChange(currentRow, FormRow.id)
              }
              updateCalculatedRows();
            }
          }}
        />
      </td>
      <td>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          textType="text"
          textAlign={"right"}
          disabled={true}
          id={"Amount" + Key}
          value={FormRow.Amount}
          onChange={e => {
            let value1 = Numeric(e.target, 15, 0, false)
            changeRowValueChanges(value1, FormRow.id, "Amount")
          }}
          onBlur={e => {


          }}
        />
      </td>
      <td>
        <Button
          outline
          disabled={Disabled}
          color="danger"
          onClick={async () => {
            await RemoveRow(FormRow.id)
          }}
          size="sm"
        >
          <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
        </Button>
      </td>

      <DPSearchBoxDynamicHeadOffice
        searchData={[]}
        columns={[]}
        defaultSorted={defaultSorted}
        mainTitle={"Voucher Group Detail Search"}
        SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
        isOpen={modal_xlarge}
        toggle={tog_xlarge}
        getSelect={Hed_SelectRowSearch}
        APIURL={ApiURL}
        URLPath={"VOUTGRP"}
        MenuCode={menuCode}
        KeyVal={'GRP'}
        searchBy={'VCG_CODE'}
        FilterStr={groupFilter}
      />

      <DPAlert
        confirm_both={sweetAlertShow}
        title={menuName}
        description={AlertDescription}
        showCancel={false}
        btnColor={"success"}
        cancelColor={"danger"}
        onConfirm={() => {
          setsweetAlertShow(false)
        }}
        btnYes={"OK"}
      />
    </tr>
  )
}